// novem atom — count pill (NovemHR-ekranlar port, Phase 8.6 promotion).
//
// The little rounded count badge that trails a tab label ("Aktif 12").
// employee-list-content.tsx and leave-list-content.tsx both re-typed the
// same span (`ml-1.5 rounded-full bg-subtle …`) inside their <Tab>
// children; this promotes it as a standalone atom so the count chrome
// lives in one place. Kept a separate atom (rather than a `count` prop on
// <Tab>) because <Tab> is a generic navigation primitive and a decorative
// count badge is composable content — same stance as FilterPillBar's
// nai-filter-pill-count, which this mirrors visually.
//
// Accessibility: a count alone ("12") is ambiguous to a screen reader when
// the surrounding label already conveys the category. The host can pass an
// "aria-label" for a clearer phrasing; otherwise the digits read in line
// with the tab label. The pill is non-interactive (<span>) — the parent
// <Tab> owns the role/keyboard model.

import { forwardRef, type HTMLAttributes, type ReactNode } from "react";

import { cx } from "../lib/cx.ts";

export interface CountPillProps extends HTMLAttributes<HTMLSpanElement> {
  /** The count to render (host supplies the formatted value, e.g. "12" or "12+"). */
  readonly children: ReactNode;
}

export const CountPill = forwardRef<HTMLSpanElement, CountPillProps>(
  ({ className, children, ...rest }, ref) => (
    <span
      ref={ref}
      data-component="count-pill"
      className={cx("nai-count-pill", className)}
      {...rest}
    >
      {children}
    </span>
  ),
);
CountPill.displayName = "CountPill";
